import { createSvgIcon } from "@mui/material";

const ArchiveDialogIcon = createSvgIcon(
  <svg viewBox="0 0 80 80" fill="none">
    <path
      d="M0 21.3333C0 9.55126 9.55126 0 21.3333 0H58.6667C70.4487 0 80 9.55126 80 21.3333V58.6667C80 70.4487 70.4487 80 58.6667 80H21.3333C9.55126 80 0 70.4487 0 58.6667V21.3333Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M18.8813 27.5394C18.8813 24.5939 21.2692 22.2061 24.2147 22.2061H60.768C63.7135 22.2061 66.1013 24.5939 66.1013 27.5394V57.4969C66.1013 60.4424 63.7135 62.8302 60.768 62.8302H24.2147C21.2692 62.8302 18.8813 60.4424 18.8813 57.4969V27.5394Z"
      fill="#E8EEF2"
    />
    <path
      d="M59.7779 51.5551V22.6662C59.7779 20.5798 58.0866 18.8885 56.0002 18.8885H36.8891C36.0299 18.8885 35.3335 18.192 35.3335 17.3329C35.3335 16.4738 36.0299 15.7773 36.8891 15.7773H56.0002C59.8048 15.7773 62.8891 18.8616 62.8891 22.6662V51.5551C62.8891 52.4142 62.1926 53.1107 61.3335 53.1107C60.4744 53.1107 59.7779 52.4142 59.7779 51.5551Z"
      fill="#B4C8D3"
    />
    <path
      d="M15.7779 53.7773V22.6662C15.7779 20.5798 17.4693 18.8885 19.5557 18.8885H30.2224C31.0815 18.8885 31.7779 18.192 31.7779 17.3329C31.7779 16.4738 31.0815 15.7773 30.2224 15.7773H19.5557C15.7511 15.7773 12.6668 18.8616 12.6668 22.6662V53.7773C12.6668 57.582 15.7511 60.6662 19.5557 60.6662H57.7779C58.6371 60.6662 59.3335 59.9698 59.3335 59.1107C59.3335 58.2516 58.6371 57.5551 57.7779 57.5551H19.5557C17.4693 57.5551 15.7779 55.8638 15.7779 53.7773Z"
      fill="#B4C8D3"
    />
    <path d="M13.3335 30.4443L13.3335 27.3332L61.3335 27.3332L61.3335 30.4443L13.3335 30.4443Z" fill="#B4C8D3" />
    <path
      d="M39.4005 50.2221C38.793 50.8296 37.8078 50.8296 37.2004 50.2221L33.5667 46.5884C32.9592 45.981 32.9592 44.9958 33.5667 44.3884C34.1552 43.7999 35.098 43.7816 35.7086 44.3332L35.7668 44.3884L38.3006 46.9226L40.8345 44.3884C41.4419 43.7811 42.4267 43.7811 43.0341 44.3884C43.6416 44.9958 43.6416 45.981 43.0341 46.5884L39.4005 50.2221Z"
      fill="#F44336"
    />
    <path
      d="M39.8555 36.0002L39.8555 49.1222C39.8555 49.9813 39.159 50.6777 38.2999 50.6777C37.4408 50.6777 36.7444 49.9813 36.7444 49.1222L36.7444 36.0002C36.7444 35.1411 37.4408 34.4447 38.2999 34.4447C39.159 34.4447 39.8555 35.1411 39.8555 36.0002Z"
      fill="#F44336"
    />
  </svg>,
  "ArchiveDialogIcon"
);

export default ArchiveDialogIcon;
